import {
  I18N_SUBMIT_CONFIRMATION_BUTTON_KEY,
  I18N_SUBMIT_DISCLAIMER_KEY,
  I18N_WARNINGS_CHECK_LABEL_KEY
} from 'lf-at-theme';

/**
 * App i18n object for the en-US locale.
 */

export const appI18NEnUS: Record<string, any> = {
  '*': {
    saveFileName: 'oss-import-registration',
    [I18N_SUBMIT_DISCLAIMER_KEY]: 'You are about to submit a Import Scheme registration. Do you wish to continue?',
    [I18N_SUBMIT_CONFIRMATION_BUTTON_KEY]: 'Submit',
    [I18N_WARNINGS_CHECK_LABEL_KEY]: 'I declare that I am aware of the warnings generated by the data of this declaration.',
    ["modalYesBtn"]: 'Confirm',
    ["modalNoBtn"]: 'Cancel',
    ["schemeConditionsTitle"]: 'Admission Conditions',
    ["schemeConditions"]: `
      <p>To register in this scheme you should meet these conditions:</p>
      <ul>
        <li>You make distance sales of goods (of products not subject to excise duty) imported from third countries or third territories, with an intrinsic value not exceeding € 150.</li>
      </ul>
    `,
  }
};
